import { ORG_SWITCHER_SLICE_NAME } from 'app/modules/orgSwitcher/sliceOrgSwitcher';

export const selectOrgSwitcher = (state: RootState) =>
  state[ORG_SWITCHER_SLICE_NAME].orgSwitcher;
